export enum RoutePathEnum {
  Home = 'home',
  Assessment = 'settings/assessment',
  BrainGame = 'settings/braingame',
  Clubhouse = 'settings/clubhouse',
  HappyPlace = 'settings/happyplace',
  Yahootie = 'settings/yahootie',
  General = 'settings/general'
}
